import type {Rec} from 'typings/portaro.be.types';
import {getRecordPath, getRecordUrlId} from '../utils/data-service-utils';

type RecordDetailPathFilter = (record: Rec) => string;

/**
 * @ngdoc filter
 * @name kpRecordDetailPath
 * @module portaro.filters
 * @kind function
 *
 * @param {{id, type}} record Record object. It must contain `id`
 *
 * @return {string} URL of record
 *
 * @description
 * Filter returns the full URL to the given record.
 */
/*@ngInject*/
export default function recordDetailPathFilter(): RecordDetailPathFilter {
    return (record: Rec) => {
        if (!record.id) {
            throw new Error('Missing record id');
        }

        return getRecordPath(getRecordUrlId(record));
    };
}

recordDetailPathFilter.filterName = 'kpRecordDetailPath';